// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'

import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'
import { Mdx, ScrollTracking, Link } from '@ta-interaktiv/contentbricks'

import { Person } from 'components/person'
import { personData, travelData } from '../../personData.js'
import CO2Viz, { Props as CO2VizProps } from 'components/co2viz'
// GLOBALS
const ARTICLE_ID = '17615737'

class AppComponent extends Component<{}> {
  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <ScrollTracking />
        <Masthead articleId={ARTICLE_ID} inverted additionalShares={940} />
        <header className='ui vertical segment' id='cover'>
          <div className='ui container'>
            <h1 className='ui header'>
              Diese Vergleiche machen Flugreisenden ein schlechtes Gewissen
            </h1>
          </div>
        </header>
        <div className='ui container'>
          <div className='ta secondary caption'>
            Foto: David Kovalenko/Unsplash
          </div>
        </div>
        <div className='ui  vertical segment'>
          <div className='ui text container'>
            <div className='ta lead'>
              Fliegen belastet das Klima so stark wie kaum eine andere
              Tätigkeit. Folgende Grafiken könnten den Passagieren in Kloten den
              Flug vermiesen.
            </div>
            <div className='ta author'>
              Von Sebastian Broschinski, Edgar Schuler und Marc Brupbacher
            </div>
          </div>
        </div>
        <div className='ui vertical segment start'>
          <div className='ui text container'>
            <Mdx file={require('text/intro.Mdx')} />
          </div>
        </div>
        {personData.map((p, i) => {
          if (i === 1)
            return (
              <>
                <div key={i}>
                  {/* <Tracking label='content25' /> */}
                  <Person {...p} />
                </div>
              </>
            )
          if (i === 2)
            return (
              <>
                <div key={i}>
                  {/* <Tracking label='content50' /> */}
                  <Person {...p} />
                </div>
              </>
            )
          return <Person {...p} key={i} />
        })}
        <div className='noPersonBG'>
          <div className='ui text container'>
            <div className='name'>
              <b>Fliegen Sie auch?</b> <br />
              Vielleicht nach New York oder Bangkok? Wir haben für Sie auch
              diese Strecken berechnet.
            </div>
            {/* <Tracking label='content75' /> */}
          </div>
          {travelData.map((t: CO2VizProps, i: number) => {
            return <CO2Viz {...t} key={i} />
          })}{' '}
        </div>
        <div className='ui vertical segment foot'>
          <Footer
            questions={[
              'Wie informativ war der Beitrag?',
              'Wie passend finden Sie die Vergleiche?',
              'Wie gefällt Ihnen die Gestaltung?'
            ]}
            articleId={ARTICLE_ID}
            credits={[
              [
                'Konzeption und Umsetzung',
                'Sebastian Broschinski und<br/> Marc Brupbacher'
              ],
              ['Interviews und Fotos', 'Edgar Schuler'],
              ['Berechnungen', 'Niels Jungbluth/ESU-services']
            ]}
          >
            <div className='ui vertical fitted attached segment' id='methodik'>
              <div
                className='ui text container methodik'
                style={{ position: 'relative' }}
              >
                <h3>Allgemeine Hinweise zu den Berechnungen</h3>

                <div className='list'>
                  <ul>
                    <li>
                      Für die Bilanz wurden Hin- und Rückflug von Zürich nach
                      Berlin, London, New York, Bangkok und Los Angeles
                      berücksichtigt.
                    </li>
                    <li>
                      Studien zu Ferienflügen inklusive Hotel, Verpflegung und
                      Freizeitaktivitäten finden Sie{' '}
                      <Link url='http://esu-services.ch/de/projekte/tourism/'>
                        hier.
                      </Link>
                    </li>
                    <li>
                      Datengrundlage:{' '}
                      <Link url='http://esu-services.ch/de/daten/datenbank/'>
                        ESU-Datenbank
                      </Link>
                    </li>
                    <li>
                      In Ökobilanzen werden nicht nur die direkten Emissionen
                      des Fahrzeugs bilanziert. Es wird der gesamte Lebenszyklus
                      berechnet. Die Werte sind deshalb z.B. deutlich höher als
                      die auf Neufahrzeugen angegebenen CO<sub>2</sub>
                      -Emissionen in g/km. Diese auf den Etiketten angegebenen
                      Emissionen sind häufig deutlich niedriger als der reale
                      Verbrauch (inkl. Klimaanlage, Licht und viele andere
                      Stromverbraucher). Berücksichtigt werden zusätzlich die
                      Herstellung des Treibstoffs, Produktion, Unterhalt und
                      Entsorgung des Fahrzeugs, der Strasse und anderer
                      Infrastruktur.
                    </li>
                    <li>
                      Verwendung der aktuellen Berechnungsmethode für das
                      Klimaänderungspotenzial in kg CO<sub>2</sub>-Äquivalenten
                      gemäss IPCC 2013, 100a unter Berücksichtigung von
                      zusätzlichem radiative forcing bei Flugtransporten
                      ((Jungbluth and Meili 2019)).
                    </li>
                    <li>
                      Quellen:
                      <br />
                      ESU (2019). The ESU database. Schaffhausen, ESU-services
                      Ltd.
                      <br /> <br /> Jungbluth, N. and C. Meili (2019).
                      «Recommendations for calculation of the global warming
                      potential of aviation including the radiative forcing
                      index». Int J Life Cycle Assess 24(3): 404–411.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Footer>
        </div>
      </div>
    )
  }
}

export default hot(AppComponent)
